import * as types from "./actionType";

const INIT_STATE = {
    franchiseLicenseList: [],
    loading: false,
    saveLoading: false,
    error: null,
    successMessage: "",
    updateMsg: null,
};

const FranchiseLicenseReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

        case types.FRANCHISE_LICENSE_GET:
            return {
                ...state,
                loading: true,
            };

        case types.FRANCHISE_LICENSE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                franchiseLicenseList: action.payload.Data || [],
            };

        case types.FRANCHISE_LICENSE_POST:
    return {
        ...state,
        saveLoading: true,
        updateMsg: null,
    };

        case types.FRANCHISE_LICENSE_POST_SUCCESS:
            return {
                ...state,
                saveLoading: false,
                successMessage: action.payload.Message,
                updateMsg: action.payload,
            };

        case types.FRANCHISE_LICENSE_API_ERROR:
            return {
                ...state,
                loading: false,
                saveLoading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default FranchiseLicenseReducer;